import React from 'react';
import { useRouter } from 'next/router';
import ChallengeDetailBanner from '@components/challenge/challengeDetailBanner';
import ChallengeDetailInfo from '@components/challenge/challengeDetailInfo';
import { useMatchChallenge } from '@repository/match';

const ChallengeDetail = () => {
  const { query, replace } = useRouter();
  const sn = Number(query.sn);
  const { data } = useMatchChallenge(sn);

  if (!data) return null;
  if (!data.openYn) {
    // 게시 off 일 경우 URL 직접 접근 시 리다이렉트를 위한 replace
    replace('/challenge');
    return null;
  }

  return (
    <>
      <ChallengeDetailBanner challengeSn={sn} />
      <ChallengeDetailInfo challengeSn={sn} />
    </>
  );
};

export default ChallengeDetail;
